"use client";

import styled from "styled-components";

//Types
interface ButtonProps {
  $widthFull?: boolean;
  $variant?: "default" | "danger" | "warning" | "success" | undefined;
  $small?: boolean;
}

interface WidthProps {
  $width: string;
}

const variantStyles = {
  default: `
        background: transparent;
        color: var(--textLight);
        border: 1px solid var(--textLight);

        &:hover {
            background: rgba(75, 85, 99, 0.1);
        }
    `,
  danger: `
        background: var(--red);
        color: var(--white);

        &:hover {
            background: #bb1b1f;
        }
    `,
  warning: `
        background: var(--yellow);
        color: var(--colorTitle);

        &:hover {
            background: #ffd000;
        }
    `,
  success: `
        background: var(--green);
        color: var(--white);

        &:hover {
        background: var(--hoverGreen);
        }
    `,
};

export const BoxDropdownGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  height: 100%;

  > button {
    border-radius: calc(0.625rem - 2px) 0 0 calc(0.625rem - 2px);
  }
`;

export const DropdownButton = styled.button<ButtonProps>`
  padding: 0.5rem 5px;
  border-radius: 5px;
  font-family: "Roboto Medium";
  font-size: 14px;
  border-radius: 0 calc(0.625rem - 2px) calc(0.625rem - 2px) 0;
  cursor: pointer;
  height: 100%;

  ${({ $variant = "default" }) => variantStyles[$variant]}

  svg {
    //width: ;
  }
`;

export const DropdownTitle = styled.h4`
  font-family: "Roboto Medium";
  color: var(--colorTitle);
  padding: calc(0.25rem * 2);
`;

export const DropdownContent = styled.div``;

export const DropdownItem = styled.div`
  padding: calc(0.25rem * 1.5) calc(0.25rem * 2);
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--colorText);
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: var(--hoverDropdownItem);
    color: var(--white);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Dropdown = styled.div<WidthProps>`
  position: absolute;
  top: 100%;
  right: 0;
  border: 1px solid #ccc;
  z-index: 1;
  display: none;
  visibility: hidden;
  opacity: 0;
  transition: 0.2s ease-in-out;
  background: var(--backgroundColor);
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: calc(0.25rem * 1);
  min-width: ${({ $width }) => $width && $width};
`;

export const DropdownBox = styled.div`
  position: relative;
  width: fit-content;
  height: 100%;

  &:hover {
    ${Dropdown} {
      display: block;
      opacity: 1;
      visibility: visible;
    }
  }
`;
